var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-file-dropzone',{attrs:{"accept":"image/*"},on:{"input":function($event){return _vm.$emit('input', $event)}}},[(_vm.value)?_c('img',{staticClass:"rounded-md",attrs:{"src":_vm.value,"alt":"Image"}}):_c('span',{staticClass:"text-gray-600 text-sm"},[_vm._v("Drop an image here or click to upload")])])
}
var staticRenderFns = []

export { render, staticRenderFns }